import type { CountryCode } from 'libphonenumber-js';
import { SelectField, TextField } from './fields';
import {
  PHONE_COUNTRIES,
  changePhoneCountry,
  countryFromPhone,
  formatInternationalPhoneInput,
} from '../lib/phone';

export function PhoneField({
  value,
  onChange,
  error,
  label = 'Telefone',
  disabled,
}: {
  value: string;
  onChange: (value: string) => void;
  error?: string | null | false;
  label?: string;
  disabled?: boolean;
}) {
  const country = countryFromPhone(value);

  return (
    <div>
      <label className="pa-form-label">{label}</label>
      <div style={{ display: 'grid', gridTemplateColumns: 'minmax(150px, 0.8fr) minmax(180px, 1.2fr)', gap: 8 }}>
        <SelectField
          value={country}
          onChange={(next) => onChange(changePhoneCountry(value, next as CountryCode))}
          options={PHONE_COUNTRIES}
          disabled={disabled}
        />
        <TextField
          value={value}
          onChange={(next) => onChange(formatInternationalPhoneInput(next, country))}
          error={error}
          placeholder="+55 11 98888-7777 (opcional)"
          inputMode="tel"
          mono
          disabled={disabled}
        />
      </div>
      {!error && <div style={{ fontSize: 11.5, color: 'var(--fg-subtle)', marginTop: 5 }}>País, DDI e DDD quando aplicável.</div>}
    </div>
  );
}
